import { makeCustomIcon } from './utils';

export const dimHunterIcon = makeCustomIcon(
  'Hunter',
  32,
  32,
  'm9.055 10.446 6.945-.023-6.948 10.451 6.948-.024-7.412 11.15h-7.045l7.036-10.428h-7.036l7.032-10.422h-7.032l7.507-11.126 6.95-.024zm13.89 0-6.945-10.446 6.95.024 7.507 11.126h-7.032l7.032 10.422h-7.036l7.036 10.428h-7.045l-7.412-11.15 6.948.024-6.948-10.451z'
);

export default dimHunterIcon;
